import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

import Loading from "../../components/shared/Loading";
import { redirectAuthenticatedUser } from "../../router/auth";

const Screen = lazy(() => import("../../views/auth/SignUp"));

export const Route = createFileRoute("/_public/sign-up")({
  component: RouteComponent,
  beforeLoad: redirectAuthenticatedUser,
  staticData: {
    routeKey: "signUp",
    access: "public-auth",
    layout: "modern",
    container: "default",
  },
});

function RouteComponent() {
  return (
    <Suspense fallback={<Loading loading={true} />}>
      <Screen />
    </Suspense>
  );
}
